<app-footer>
  <div class="inspection-footer" (click)="onFooterClick()">
    <div class="qr-inspection">
      <div class="qr-inspection__qr">
        @if (isTicketValid) {
          <app-aztec-code [base64Aztec]="orderData?.base64Aztec ?? ''"></app-aztec-code>
        }
      </div>

      @if (orderData) {
        <div class="qr-inspection__information">
          <div class="qr-inspection__field">
            <span class="qr-inspection__label">{{'web.ticketValidFromLabel' | translate }}</span>
            <span class="qr-inspection__value">
              {{ orderData.validFrom | danishTime | date:'dd.MM.yy, HH:mm:ss' }}
            </span>
          </div>
          <div class="qr-inspection__field">
            <span class="qr-inspection__label">{{'web.ticketNumberLabel' | translate }}</span>
            <span class="qr-inspection__value">
              {{ orderData.ticketNumber }}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
</app-footer>

<app-inspection-modal
  [isOpen]="isInspectionModalOpen"
  [orderData]="orderData"
  [isTicketValid]="isTicketValid"
  (close)="closeInspectionModal()">
</app-inspection-modal>
